import { makeStylesheetLink } from "../stylesheet";

export class GalleryPhotosSwap extends HTMLElement {
	button: HTMLButtonElement;
	shadow: ShadowRoot;
	photoIndex: number;

	constructor() {
		super();
		this.shadow = this.attachShadow({ mode: "open" });

		this.button = document.createElement("button");
		this.button.type = "button";

		this.photoIndex = parseInt(this.dataset.page || "0");

		this.shadow.appendChild(this.button);
	}

	connectedCallback() {
		this.button.className = "gct-overlay-btn";
		this.button.style.width = '100%';
		this.button.style.height = '100%';
		this.button.style.background = 'transparent';
		this.button.style.border = 'none';
		this.button.style.cursor = 'pointer';
		this.photoIndex = parseInt(this.dataset.page || "0");
		this.button.addEventListener("click", () => {
			const largeImages = document.querySelectorAll<HTMLImageElement>("#gct-sp-large-gallery-image img");

			largeImages.forEach(img => img.classList.remove("active"));
			largeImages[this.photoIndex].classList.add("active");

			// For future styling of active thumbnail
			document.querySelectorAll(".gct-gallery-item").forEach(g => g.classList.remove("active"));
			this.button.closest(".gct-gallery-item")?.classList.add("active");
		});
	}

}
